// Stub: browser events not used in Node
export const eventHub = { on: () => {}, off: () => {}, emit: () => {}, once: () => {} };
export const EVENT_ON_UNRESOLVED_ERROR = "on-unresolved-error";
export const EVENT_REQUEST_RELOAD_SETTING_TAB = "reload-setting-tab";
export const EVENT_PLUGIN_UNLOADED = "plugin-unloaded";
